// imageObj should contain:
// "imageId": "string",
// "indexNr": 0,
// "legend": "string",

export default function useImagesArray(receivedImageArray, arrayCapacity) {
  let imageArray = receivedImageArray?.filter((image) => {
    return !!image.imageId;
  });
  const missingImagesCount = arrayCapacity - (imageArray?.length || 0);
  if (!imageArray) {
    // fill the array with empty image elements
    imageArray = Array.from({ length: arrayCapacity }, (_, i) => {
      return { imageId: null, indexNr: i, legend: '' };
    });
  } else if (missingImagesCount > 0) {
    // find the missing elements, make mock objects and sort the array
    const allImageIndexes = Array.from({ length: arrayCapacity }, (_, i) => i);
    const containedImageIndexes = imageArray.map((image) => image.indexNr);
    const missingImageIndexes = allImageIndexes.filter((imageIndex) => {
      return !containedImageIndexes.includes(imageIndex);
    });
    missingImageIndexes.forEach((missingIndex) => {
      imageArray.push({
        imageId: null,
        indexNr: missingIndex,
        legend: '',
      });
    });
  }
  imageArray.sort((a, b) => a.indexNr - b.indexNr);
  return { imageArray };
}

export const getImagesArray = (receivedImageArray, arrayCapacity) => {
  let imageArray = receivedImageArray?.filter((image) => {
    return !!image.imageId;
  });

  const missingImagesCount = arrayCapacity - (imageArray?.length || 0);

  if (!imageArray) {
    // fill the array with empty image elements
    imageArray = Array.from({ length: arrayCapacity }, (_, i) => {
      return { imageId: null, indexNr: i, legend: '' };
    });
  } else if (missingImagesCount > 0) {
    // find the missing elements, make mock objects and sort the array
    const allImageIndexes = Array.from({ length: arrayCapacity }, (_, i) => i);
    const containedImageIndexes = imageArray.map((image) => image.indexNr);
    const missingImageIndexes = allImageIndexes.filter((imageIndex) => {
      return !containedImageIndexes.includes(imageIndex);
    });
    missingImageIndexes.forEach((missingIndex) => {
      imageArray.push({
        imageId: null,
        indexNr: missingIndex,
        legend: '',
      });
    });
  }

  imageArray.sort((a, b) => a.indexNr - b.indexNr);

  return { imageArray: imageArray.slice(0, arrayCapacity) };
};
